import BaseAPI from './base'
/**
 * API xử lý học sinh đổi quà
 */
class GiftExchangeHistoryAPI extends BaseAPI {}

export default new GiftExchangeHistoryAPI('v1/gift-exchange-history', 'GiftExchangeHistory')
